import { useState, useEffect } from 'react';
import quranApi from '../../api/quranApi';

const ReciterSelector = ({ selectedReciter, onSelectReciter }) => {
    const [reciters, setReciters] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReciters = async () => {
            try {
                const data = await quranApi.getReciters();
                // Filter for popular reciters to avoid overwhelming list, or just show all
                // For now, let's filter for audio only and maybe sort
                const audioReciters = data.filter(r => r.format === 'audio' && r.type === 'versebyverse');
                setReciters(audioReciters);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching reciters', error);
                setLoading(false);
            }
        };

        fetchReciters();
    }, []);

    if (loading) return <div>Chargement des récitateurs...</div>;

    return (
        <div className="reciter-selector">
            <label>Choisir un récitateur :</label>
            <select
                value={selectedReciter}
                onChange={(e) => onSelectReciter(e.target.value)}
                className="form-control"
            >
                {reciters.map((reciter) => (
                    <option key={reciter.identifier} value={reciter.identifier}>
                        {reciter.englishName} ({reciter.language})
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ReciterSelector;
